export default "__VITE_ASSET__BPUa25jv__"